import { FieldWrapper } from 'DesignSystem';
import { useField } from 'formik';
import React, { FC, ReactNode } from 'react';
import CountryMultiselectAutocomplete from './CountryMultiselectAutocomplete';

interface ICountryMultiselectFieldProps {
  name: string;
  size?: 'small' | 'medium';
  label?: string;
  labelVariant?: 'small' | 'medium' | 'large';
  placeholder?: string;
  isRequired?: boolean;
  helperText?: string | ReactNode;
  disabled?: boolean;
  'data-testid'?: string;
  euCountriesOnly?: boolean;
  showCountryRisk?: boolean;
  maxSelections?: number;
}

const CountryMultiselectField: FC<ICountryMultiselectFieldProps> = ({
  name,
  size = 'small',
  label = 'Countries',
  labelVariant = 'small',
  isRequired,
  helperText,
  disabled,
  euCountriesOnly,
  showCountryRisk,
  maxSelections,
  'data-testid': testId,
}) => {
  const [field, meta, helper] = useField<string[]>(name);

  const handleSelectionChange = async (selection: string[]) => {
    await helper.setTouched(true);
    helper.setValue(selection);
  };

  return (
    <FieldWrapper
      label={label}
      variant={labelVariant}
      required={isRequired}
      tooltip={
        helperText
          ? {
              helperText,
              variant: 'INFO',
            }
          : undefined
      }
    >
      <CountryMultiselectAutocomplete
        value={field.value || []}
        size={size}
        disabled={disabled}
        errorMessage={meta.error}
        hasError={!!meta.error && meta.touched}
        onCountrySelect={handleSelectionChange}
        data-testid={testId}
        euCountriesOnly={euCountriesOnly}
        showCountryRisk={showCountryRisk}
        maxSelections={maxSelections}
      />
    </FieldWrapper>
  );
};

export default CountryMultiselectField;
